/**
 * Leave the widget for a full page (hosted checkout, merchant booking page).
 *
 * Site builders such as Wix, Google Sites and GoDaddy run HTML embeds inside a
 * sandboxed iframe. `window.location.href` there navigates the iframe, so the
 * checkout rendered inside an 800px box on the merchant's page. GoDaddy's
 * srcdoc frame is same-origin (sandbox has allow-same-origin), so any frame,
 * not only a cross-origin one, goes to the top window. Checkout inside a
 * third-party frame gets no cookies and re-initialises in a loop.
 */
export function navigateOut(url: string): void {
  if (typeof window === 'undefined' || window.top === window) {
    window.location.href = url;
    return;
  }

  try {
    window.top!.location.href = url;
  } catch {
    // Sandbox without allow-top-navigation (Wix). allow-popups is still set.
    window.open(url, '_blank');
  }
}
